exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: horizontal;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-flow: row nowrap;\r\n          flex-flow: row nowrap;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 1000;\r\n  box-sizing: border-box;\r\n  background-color: #673AB7;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.notification__image {\r\n  display: block;\r\n  width: 40px;\r\n  height: 40px;\r\n  padding: 10px;\r\n}\r\n\r\n.notification__text {\r\n  width: 100%;\r\n}\r\n\r\n.notification__title {\r\n  color: rgba(255, 255, 255, 0.9);\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.notification__body {\r\n  color: rgba(255, 255, 255, 0.7);\r\n  font-size: 0.76rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/notification/notification.component.css
// module id = ../../../../../src/app/notification/notification.component.css
// module chunks = 4